// Leaf Custom Code - Cart Upsell - Start
(function () {

  // Suppress view_item_list briefly on bfcache restore: the browser brings back the
  // page with Alpine's cart drawer state still active, and any pending cartAiReco()
  // fetch from before navigation would complete and fire cart-ai-reco-rendered.
  var bfcacheCooldown = false;
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      bfcacheCooldown = true;
      setTimeout(function () { bfcacheCooldown = false; }, 3000);
    }
  });

  function getUpsellItems() {
    var items = [];
    document.querySelectorAll('#cart-ai-recommended-splide .cart-ai-reco__product-item').forEach(function (el, index) {
      var name = el.querySelector('.cart-ai-reco__product-title')?.innerText?.trim();
      var priceEl = el.querySelector('.cart-ai-reco__product-price');
      var price = parseFloat(priceEl?.innerText?.replace(/[^0-9.]/g, '')) || 0;
      var btn = el.querySelector('.cart-ai-reco-product_cta');
      var clickAttr = btn ? (btn.getAttribute('@click.prevent') || '') : '';
      var idMatch = clickAttr.match(/id:\s*(\d+)/);
      var itemId = idMatch ? idMatch[1] : '';

      if (name) {
        items.push({
          item_name: name,
          item_id: itemId,
          price: price,
          index: index,
          quantity: 1
        });
      }
    });
    return items;
  }

  function pushViewItemList() {
    var items = getUpsellItems();
    if (!items.length) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'view_item_list_upsell',
      ecommerce: {
        item_list_id: 'cart_upsell',
        item_list_name: 'Cart Upsell Recommendations',
        items: items
      }
    });

    console.log('[DataLayer] view_item_list fired', items);
  }

  // Fires when recommendations are freshly fetched and rendered into the DOM
  // Guards: cart drawer must be open, and page must not be a bfcache restoration
  window.addEventListener('cart-ai-reco-rendered', function () {
    if (bfcacheCooldown) return;
    if (!document.querySelector('.cart-drawer-open')) return;
    pushViewItemList();
  });

})();
// Leaf Custom Code - Cart Upsell - Finish

// Leaf Custom Code - Cart Upsell Add to Cart - Start
(function () {
  var lastAddedId = null;
  var lastAddedTime = 0;
  var ATC_DEBOUNCE_MS = 2000;

  window.addEventListener('cart-ai-add-to-cart', function (event) {
    var variantId = event.detail && event.detail.id ? String(event.detail.id) : '';
    var now = Date.now();

    // Deduplicate: ignore if the same variant was pushed within 2 seconds
    if (variantId && variantId === lastAddedId && now - lastAddedTime < ATC_DEBOUNCE_MS) return;
    lastAddedId = variantId;
    lastAddedTime = now;

    // Alpine sets s--loading on the button before dispatching, so we can find which item was clicked
    var btn = document.querySelector('#cart-ai-recommended-splide .cart-ai-reco-product_cta.s--loading');
    if (!btn) return;

    var item = btn.closest('.cart-ai-reco__product-item');
    if (!item) return;

    var name = item.querySelector('.cart-ai-reco__product-title')?.innerText?.trim();
    var priceEl = item.querySelector('.cart-ai-reco__product-price');
    var price = parseFloat(priceEl?.innerText?.replace(/[^0-9.]/g, '')) || 0;
    var itemId = event.detail && event.detail.id ? String(event.detail.id) : '';

    if (!name) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart_upsell',
      ecommerce: {
        currency: 'GBP',
        value: price,
        items: [{
          item_name: name,
          item_id: itemId,
          price: price,
          item_list_name: 'Cart Upsell Recommendations',
          item_list_id: 'cart_upsell',
          quantity: 1
        }]
      }
    });

    console.log('[DataLayer] add_to_cart (upsell) fired', name, itemId, price);
  });

})();
// Leaf Custom Code - Cart Upsell Add to Cart - Finish
